import * as actions from './actionTypes';

export const storeLogout = () => ({ type: actions.AUTH_LOGOUT });
export const storeRefresh = () => ({ type: actions.AUTH_REFRESH });
export const storeLogin = (user) => ({
  type: actions.AUTH_LOGIN,
  user,
});
